import React from 'react';
import styled, {css} from 'styled-components';
import Button from './button';

const Container = styled.div`
	display: inline-table;
	position: relative;
	cursor: pointer;
	overflow: hidden;
	margin: ${props => props.margin};
	width: ${props => props.width};
	ps-button {
		z-index: 0;
	}
	&:hover {
		.ps-button:not(.disabled) {
			text-decoration: underline;
		}
	}
`;

const InputOverlay = styled.input`
	position: absolute;
	opacity: 0;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	font-size: 1px;
	&:not(.disabled) {
		cursor: pointer;

		&::-webkit-file-upload-button {
			cursor: pointer;
		}
	}
	z-index: 1;
`;

export default class FileInput extends React.Component {
	constructor() {
		super();
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		if (this.props.onChange) {
			this.props.onChange(e.target.files);
		}
	}

	render() {
		return (
			<Container className="ps-input file" margin={this.props.margin} width={this.props.width}>
				<InputOverlay
					type="file"
					onChange={this.onChange}
					disabled={this.props.disabled}
					className={this.props.disabled ? 'disabled' : ''}
				/>
				<Button
					{...this.props}
					margin="0px"
					width="100%"
				/>
			</Container>
		);
	}
}